import styled from 'styled-components';

export const Wrapper = styled.div`
  z-index: 100;
  width: 100vw;
  height: 100vh;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
`;
